export default {
    AudioStore: {
        getdata: [],
    }
};